import React from 'react';
import FilterWidgetFieldEntity from '../../FilterWidgetFieldEntity';
import {
  IFieldFieldsFragment,
  INamedFilterFieldsFragment,
} from '../../../../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../../../../utils/types';

interface IProps {
  value: IFieldFieldsFragment | null;
  onChange: (
    newValue: IFieldFieldsFragment | INamedFilterFieldsFragment | null,
  ) => void;
  placeholder: string;
  autoFocus?: boolean;
  hasError: boolean;
}

const SingleOperandField = ({
  value,
  onChange,
  placeholder,
  autoFocus,
  hasError,
}: IProps) => {
  const handleChange = (
    newValue: IFieldFieldsFragment | INamedFilterFieldsFragment | null,
  ) => {
    if (!newValue) {
      onChange(null);
      return;
    }

    assertCondition(newValue.__typename === 'Field');

    onChange(newValue);
  };

  return (
    <FilterWidgetFieldEntity
      field={value}
      onChange={handleChange}
      placeholder={placeholder}
      allowNamedFilter={false}
      allowField={true}
      operandTypeIsField={true}
      autoFocus={autoFocus}
      hasError={hasError}
    />
  );
};

export default SingleOperandField;
